module.exports = __webpack_public_path__ + "static/media/career-info-icon.1741aea2.png";